module.exports = __webpack_public_path__ + "img/buy_super_zh.c5b36ad6.png";